// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"894f0fa5","91":"a90cd468","136":"43b6fdd1","155":"48b7299d","202":"effcdb48","383":"3329110c","392":"57ad39e5","424":"389c742e","688":"a3d86da0","740":"d862ed43","840":"a64c09cc","950":"24b46808","976":"c55815a9"}[chunkId] + ".chunk.js";
};